import React, { useEffect, useState } from 'react';
import './PlayListItem.css';

const PlaylistItem = ({list}) => {
    // console.log(list.snippet.title);
    const img = list?.snippet?.thumbnails?.medium?.url
    
    const [matchers, setMatchers] = useState([])
    const[listVideos, setListVideos] = useState([]);

    useEffect(() =>{
        fetch(
          `https://youtube.googleapis.com/youtube/v3/playlistItems?part=snippet&playlistId=${list.id}&maxResults=20&key=${process.env.REACT_APP_apiKey_alter}`
        )
          .then((res) => res.json())
          .then((data) => setListVideos(data));
    },[list])

    // console.log(listVideos);
    const vdo = listVideos?.items
    const VdoItems =  vdo?.map(listVideo => listVideo?.snippet)

    const SendPlaylistId = (listId) => {
            const matchedVdo = VdoItems?.filter(matched => matched.playlistId === listId)
            setMatchers(matchedVdo);    
        }  
        

    return (
      <div className="bg-purple-700 px-3 py-2 rounded-lg max-h-64 overflow-x-hidden overflow-y-scroll scroll-smooth scrollbar-hide">
        <div
          onClick={() => SendPlaylistId(list.id)}
          className="card cursor-pointer bg-purple-700"
        >
          <div className="flex items-center gap-1 pb-1 ">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              className="stroke-current flex-shrink-0 w-6 h-6 text-slate-300"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              ></path>
            </svg>
            <span className="text-slate-300 text-sm">
              Click & scroll to see playlist videos.
            </span>
          </div>
          <figure>
            <img className="rounded-lg" src={img} alt="car!" />
          </figure>
          <div className="card-body px-3 py-0 mx-auto">
            <h2 className="card-title  text-white text-lg uppercase ">
              {list?.snippet?.title}
            </h2>
          </div>
        </div>
        {matchers.map((vid) => {
          return (
            <div className="bg-purple-700 md:w-60 w-40">
              <div className="card mt-5 border card-compact w-80 bg-base-100 shadow-xl">
                <figure className="">
                  <iframe
                    className=""
                    id="ytplayer"
                    type="text/html"
                    width="350"
                    height="200"
                    src={`https://www.youtube.com/embed/${vid.resourceId.videoId}?rel=0`}
                    title="Youtube-Player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </figure>
                <div className="card-body">
                  <h2 className="card-title text-sm">{vid?.title}</h2>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
};

export default PlaylistItem;